module.exports = __webpack_public_path__ + "img/1-22.1ecf7ae8.png";